import { Helmet } from 'react-helmet-async';
import React, { useState, useRef } from "react";
import Sidebar from './sidebar';
import axios from "axios";
import { FaMicrophone, FaArrowRight } from "react-icons/fa";

export default function VoiceOrderAI() {
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [recording, setRecording] = useState(false);
  const [cart, setCart] = useState([]);
  const [transcript, setTranscript] = useState("");
  const [loading, setLoading] = useState(false);
  const mediaRecorderRef = useRef(null);
  const audioChunks = useRef([]);

  const startRecording = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    mediaRecorderRef.current = new MediaRecorder(stream);
    mediaRecorderRef.current.start();

    audioChunks.current = [];

    mediaRecorderRef.current.ondataavailable = (event) => {
      if (event.data.size > 0) {
        audioChunks.current.push(event.data);
      }
    };

    mediaRecorderRef.current.onstop = async () => {
      const audioBlob = new Blob(audioChunks.current, { type: "audio/wav" });
      const formData = new FormData();
      formData.append("audio", audioBlob);

      setLoading(true);
      try {
        const res = await axios.post(baseUrl + "/voice-order-ai/", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        setTranscript(res.data.transcript || "");
        setCart(res.data.items || []);
      } catch (err) {
        console.error("Upload error:", err);
      } finally {
        setLoading(false);
      }
    };

    setRecording(true);
    setTranscript("");
    setCart([]);
  };

  const stopRecording = () => {
    mediaRecorderRef.current.stop();
    setRecording(false);
  };

  return (
    <>                                           
      <Helmet>
        <title>Voice Assistant</title>
        <meta name="description" content="Voice Assistant" />
      </Helmet>
      <section className="container mtopcon dashb">
        <div className="row">
          <div className="col-12 col-lg-2 dash-min mb-3">
            <div className="nav-left-sidebar sidebar-dark pc">
              <div className="slimScrollDiv">
                <div className="menu-list">
                  <nav className="navbar navbar-expand-lg navbar-light nav-l-con">
                    <a className="d-xl-none d-lg-none" href="#"></a>
                    <button
                      className="navbar-toggler"
                      type="button"
                      data-toggle="collapse"
                      data-target="#navbarNav"
                      aria-controls="navbarNav"
                      aria-expanded="false"
                      aria-label="Toggle navigation"
                    >
                      <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                      <Sidebar />
                    </div>
                  </nav>
                </div>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-10 dash-max">
            <div className="row mb-3 ph-header-con">
              <div className="col-12 pt-2">
                <h6 className="pageheader-title mb-3">Voice Assistant (v0)</h6>
              </div>
            </div>
            <div className="row dashhome-rw">
              <div className="col-12 mb-4">
                <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-inherit">
                  <div className="row w-100 justify-content-center">
                    <div className="col-12 col-lg-4 reglogincon">
                      <div className="card shadow-none bg-inherit border-0">
                        <div className="card-body text-center">

                          {/* Waveform placeholder */}
                          <div className="d-flex justify-content-center mb-4">
                            <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
                              {[1, 2, 3, 4, 5].map((bar, idx) => (
                                <div
                                  key={idx}
                                  style={{
                                    width: "6px",
                                    height: `${8 + bar * 6}px`,
                                    backgroundColor: "#6c757d",
                                    borderRadius: "3px",
                                    animation: recording
                                      ? "pulse 0.8s infinite ease-in-out alternate"
                                      : "none",
                                  }}
                                ></div>
                              ))}
                            </div>
                          </div>

                          {/* Mic button */}
                          <button
                            onClick={recording ? stopRecording : startRecording}
                            className="btn btn-light rounded-circle shadow mt-2"
                            style={{
                              width: "70px",
                              height: "70px",
                              backgroundColor: recording ? "#f8d7da" : "#f1f1f1",
                              border: "1px solid #ccc",
                            }}
                          >
                            <FaMicrophone
                              size={28}
                              color={recording ? "#dc3545" : "#6c757d"}
                            />
                          </button>
                          <div className="mt-2 text-muted">
                            {recording ? "Recording..." : "Push to Speak"}
                          </div>

                          {/* Transcript / Loader + forward button */}
                          {loading ? (
                            <div className="d-flex justify-content-center mt-3">
                              <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                              <span className="ms-2 text-dark">Processing speech...</span>
                            </div>
                          ) : (
                            transcript && (
                              <div className="input-group mt-3">
                                <input
                                  type="text"
                                  className="form-control"
                                  value={transcript}
                                  readOnly
                                />
                                <button className="btn btn-primary" type="button">
                                  <FaArrowRight />
                                </button>
                              </div>
                            )
                          )}

                          {/* Detected items */}
                          {!loading && cart.length > 0 && (
                            <div className="mt-4 text-start">
                              <h6 className="text-dark">Detected Items:</h6>
                              <ul className="text-dark">
                                {cart.map((item, i) => (
                                  <li key={i}>
                                    {item.quantity} × {item.name}
                                  </li>
                                ))}
                              </ul>
                            </div>
                          )}

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Keyframes for waveform animation */}
      <style>
        {`
          @keyframes pulse {
            0% { transform: scaleY(0.6); }
            100% { transform: scaleY(1.4); }
          }
        `}
      </style>
    </>
  );
}
